import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import { Badge } from '../components/ui/badge';
import { 
  Shield, Target, Activity, Globe, Eye, 
  CheckCircle2, ArrowRight, TrendingUp, Brain, Sparkles, Lock, Database
} from 'lucide-react';
import { flagshipProducts, featuredService } from '../data/mock';

const Products = () => {
  const iconMap = {
    Shield: Shield,
    Target: Target,
    Activity: Activity,
    Globe: Globe,
    Eye: Eye,
    Brain: Brain,
    Lock: Lock,
    Database: Database
  };

  // Combine featured service with other products
  const allProducts = [featuredService, ...flagshipProducts];

  return (
    <div className="page-container">
      {/* Hero Section */}
      <section className="products-hero">
        <div className="products-hero-content">
          <Badge className="hero-badge">AI-Powered Platforms</Badge>
          <h1 className="products-hero-title">
            Enterprise-Grade AI Security Solutions
          </h1>
          <p className="products-hero-description">
            Comprehensive suite of AI-first cybersecurity platforms designed to detect, prevent, and respond to sophisticated cyber threats. 
            Built on machine learning, automated intelligence, and continuous validation.
          </p>
        </div>
      </section>

      {/* Feature Comparison Grid */}
      <section className="section">
        <div className="section-content">
          <div className="section-header">
            <h2 className="section-title">Product Comparison Matrix</h2>
            <p className="section-description">
              Choose the right solution for your security needs
            </p>
          </div>
          <div className="comparison-table-container">
            <table className="comparison-table">
              <thead>
                <tr>
                  <th>Feature</th>
                  <th>Iris XDR</th>
                  <th>Iris BAS</th>
                  <th>Iris CTEM</th>
                  <th>Iris EASM</th>
                  <th>Iris SOC</th>
                  <th>Iris EDR</th>
                  <th>Iris DLP</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>AI-Powered Threat Detection</td>
                  <td><CheckCircle2 className="check" /></td>
                  <td>-</td>
                  <td><CheckCircle2 className="check" /></td>
                  <td><CheckCircle2 className="check" /></td>
                  <td><CheckCircle2 className="check" /></td>
                  <td><CheckCircle2 className="check" /></td>
                  <td>-</td>
                </tr>
                <tr>
                  <td>Automated Response & Remediation</td>
                  <td><CheckCircle2 className="check" /></td>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                  <td><CheckCircle2 className="check" /></td>
                  <td><CheckCircle2 className="check" /></td>
                  <td>-</td>
                </tr>
                <tr>
                  <td>Continuous Security Validation</td>
                  <td>-</td>
                  <td><CheckCircle2 className="check" /></td>
                  <td><CheckCircle2 className="check" /></td>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                </tr>
                <tr>
                  <td>AI-Based Risk Prioritization</td>
                  <td>-</td>
                  <td>-</td>
                  <td><CheckCircle2 className="check" /></td>
                  <td><CheckCircle2 className="check" /></td>
                  <td>-</td>
                  <td><CheckCircle2 className="check" /></td>
                  <td><CheckCircle2 className="check" /></td>
                </tr>
                <tr>
                  <td>External Attack Surface Monitoring</td>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                  <td><CheckCircle2 className="check" /></td>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                </tr>
                <tr>
                  <td>Third-Party Risk Assessment (TPRM)</td>
                  <td>-</td>
                  <td>-</td>
                  <td><CheckCircle2 className="check" /></td>
                  <td><CheckCircle2 className="check" /></td>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                </tr>
                <tr>
                  <td>Vendor Security Monitoring</td>
                  <td>-</td>
                  <td>-</td>
                  <td><CheckCircle2 className="check" /></td>
                  <td><CheckCircle2 className="check" /></td>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                </tr>
                <tr>
                  <td>Supply Chain Threat Intelligence</td>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                  <td><CheckCircle2 className="check" /></td>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                </tr>
                <tr>
                  <td>ML-Powered Anomaly Detection</td>
                  <td><CheckCircle2 className="check" /></td>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                  <td><CheckCircle2 className="check" /></td>
                  <td><CheckCircle2 className="check" /></td>
                  <td><CheckCircle2 className="check" /></td>
                </tr>
                <tr>
                  <td>AI Model Attack Protection</td>
                  <td><CheckCircle2 className="check" /></td>
                  <td><CheckCircle2 className="check" /></td>
                  <td>-</td>
                  <td>-</td>
                  <td><CheckCircle2 className="check" /></td>
                  <td>-</td>
                  <td>-</td>
                </tr>
                <tr>
                  <td>Deepfake & AI-Generated Threat Detection</td>
                  <td><CheckCircle2 className="check" /></td>
                  <td>-</td>
                  <td>-</td>
                  <td><CheckCircle2 className="check" /></td>
                  <td><CheckCircle2 className="check" /></td>
                  <td>-</td>
                  <td>-</td>
                </tr>
                <tr>
                  <td>Adversarial AI Attack Simulation</td>
                  <td>-</td>
                  <td><CheckCircle2 className="check" /></td>
                  <td><CheckCircle2 className="check" /></td>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                </tr>
                <tr>
                  <td>LLM & Prompt Injection Protection</td>
                  <td><CheckCircle2 className="check" /></td>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                  <td><CheckCircle2 className="check" /></td>
                  <td>-</td>
                  <td><CheckCircle2 className="check" /></td>
                </tr>
                <tr>
                  <td>24/7 Continuous Operations</td>
                  <td><CheckCircle2 className="check" /></td>
                  <td><CheckCircle2 className="check" /></td>
                  <td><CheckCircle2 className="check" /></td>
                  <td><CheckCircle2 className="check" /></td>
                  <td><CheckCircle2 className="check" /></td>
                  <td><CheckCircle2 className="check" /></td>
                  <td><CheckCircle2 className="check" /></td>
                </tr>
                <tr>
                  <td>Endpoint Behavioral Analytics</td>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                  <td><CheckCircle2 className="check" /></td>
                  <td>-</td>
                </tr>
                <tr>
                  <td>Ransomware Rollback</td>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                  <td><CheckCircle2 className="check" /></td>
                  <td>-</td>
                </tr>
                <tr>
                  <td>Fileless Malware Detection</td>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                  <td><CheckCircle2 className="check" /></td>
                  <td>-</td>
                </tr>
                <tr>
                  <td>MITRE ATT&CK Mapping</td>
                  <td><CheckCircle2 className="check" /></td>
                  <td><CheckCircle2 className="check" /></td>
                  <td>-</td>
                  <td>-</td>
                  <td><CheckCircle2 className="check" /></td>
                  <td><CheckCircle2 className="check" /></td>
                  <td>-</td>
                </tr>
                <tr>
                  <td>AI Data Classification</td>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                  <td><CheckCircle2 className="check" /></td>
                </tr>
                <tr>
                  <td>GenAI/ChatGPT Governance</td>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                  <td><CheckCircle2 className="check" /></td>
                </tr>
                <tr>
                  <td>Data Lineage Tracking</td>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                  <td><CheckCircle2 className="check" /></td>
                </tr>
                <tr>
                  <td>Cloud/SaaS DLP</td>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                  <td><CheckCircle2 className="check" /></td>
                </tr>
                <tr>
                  <td>Endpoint Data Controls</td>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                  <td><CheckCircle2 className="check" /></td>
                  <td><CheckCircle2 className="check" /></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>

      {/* Detailed Product Sections */}
      {allProducts.map((product, index) => {
        const IconComponent = iconMap[product.icon];
        const isEven = index % 2 === 0;
        
        return (
          <section 
            key={product.id} 
            id={product.shortName.toLowerCase()} 
            className={`section product-detail-section ${isEven ? 'bg-light' : 'bg-white'}`}
          >
            <div className="section-content">
              <div className={`product-detail-grid ${!isEven ? 'reverse' : ''}`}>
                <div className="product-detail-image">
                  <img 
                    src={product.image} 
                    alt={product.name}
                    className="product-img"
                  />
                </div>
                <div className="product-detail-content">
                  <div className="product-detail-icon">
                    <IconComponent className="icon" />
                  </div>
                  <h2 className="product-detail-title">{product.name}</h2>
                  <p className="product-detail-tagline">{product.tagline}</p>
                  <p className="product-detail-description">{product.description}</p>
                  
                  {/* Problem Statement */}
                  <div className="product-section">
                    <h3 className="product-section-title">Problem Statement</h3>
                    <p className="product-section-text">{product.problemStatement}</p>
                  </div>

                  {/* Architecture */}
                  <div className="product-section">
                    <h3 className="product-section-title">Architecture Overview</h3>
                    <p className="product-section-text">{product.architecture}</p>
                  </div>

                  {/* Tabs for Features, Benefits, Use Cases */}
                  <Tabs defaultValue="features" className="product-tabs">
                    <TabsList className="tabs-list">
                      <TabsTrigger value="features">Key Features</TabsTrigger>
                      <TabsTrigger value="benefits">Benefits</TabsTrigger>
                      <TabsTrigger value="usecases">Use Cases</TabsTrigger>
                    </TabsList>
                    <TabsContent value="features" className="tabs-content">
                      <ul className="feature-list">
                        {product.features.map((feature, idx) => (
                          <li key={idx} className="feature-item">
                            <CheckCircle2 className="feature-check" />
                            <span>{feature}</span>
                          </li>
                        ))}
                      </ul>
                    </TabsContent>
                    <TabsContent value="benefits" className="tabs-content">
                      <ul className="feature-list">
                        {product.benefits.map((benefit, idx) => (
                          <li key={idx} className="feature-item">
                            <TrendingUp className="feature-check" />
                            <span>{benefit}</span>
                          </li>
                        ))}
                      </ul>
                    </TabsContent>
                    <TabsContent value="usecases" className="tabs-content">
                      <ul className="feature-list">
                        {product.useCases.map((useCase, idx) => (
                          <li key={idx} className="feature-item">
                            <ArrowRight className="feature-check" />
                            <span>{useCase}</span>
                          </li>
                        ))}
                      </ul>
                    </TabsContent>
                  </Tabs>

                  <Button asChild size="lg" className="product-cta">
                    <Link to="/contact">Request Demo</Link>
                  </Button>
                </div>
              </div>
            </div>
          </section>
        );
      })}

      {/* ROI Impact Section */}
      <section className="section roi-section">
        <div className="section-content">
          <div className="section-header">
            <h2 className="section-title">Quantifiable ROI Impact</h2>
            <p className="section-description">
              Measurable security improvements and cost savings
            </p>
          </div>
          <div className="roi-grid">
            <Card className="roi-card">
              <CardHeader>
                <CardTitle className="roi-metric">75%</CardTitle>
                <CardDescription>Reduction in MTTD</CardDescription>
              </CardHeader>
              <CardContent>
                <p>Iris XDR reduces Mean Time to Detect from hours to minutes</p>
              </CardContent>
            </Card>
            <Card className="roi-card">
              <CardHeader>
                <CardTitle className="roi-metric">70%</CardTitle>
                <CardDescription>False Positive Reduction</CardDescription>
              </CardHeader>
              <CardContent>
                <p>AI-powered correlation eliminates noise and alert fatigue</p>
              </CardContent>
            </Card>
            <Card className="roi-card">
              <CardHeader>
                <CardTitle className="roi-metric">24/7</CardTitle>
                <CardDescription>Continuous Validation</CardDescription>
              </CardHeader>
              <CardContent>
                <p>BAS platform provides continuous security control testing</p>
              </CardContent>
            </Card>
            <Card className="roi-card">
              <CardHeader>
                <CardTitle className="roi-metric">99.9%</CardTitle>
                <CardDescription>Detection Accuracy</CardDescription>
              </CardHeader>
              <CardContent>
                <p>ML-powered threat detection with industry-leading accuracy</p>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="cta-content">
          <h2 className="cta-title">Ready to Experience AI-Powered Security?</h2>
          <p className="cta-description">
            Schedule a personalized demo and see how our platforms can transform your security operations
          </p>
          <Button asChild size="lg" className="cta-button-primary">
            <Link to="/contact">Schedule Demo</Link>
          </Button>
        </div>
      </section>
    </div>
  );
};

export default Products;
